import type { SupportSession } from "@src/types/vpn-support-session";
import apiUseCases from "@src/cloud-connect/api";
import { postVPNDenySupportSessionDto } from "@src/cloud-connect/api/vpn-manager/vpn-post-deny-support-session";
import { parseAxiosApiError } from "@src/cloud-connect/utils/parse-axios-api-error";

export const postVPNDenySupportSessionUseCase = async (
  payload: postVPNDenySupportSessionDto,
): Promise<{
  success: boolean;
  data?: SupportSession;
  error?: string;
}> => {
  try {
    const response = await apiUseCases.postVPNDenySupportSession(payload);

    return {
      success: true,
      data: response,
    };
  } catch (error) {
    return {
      success: false,
      error: parseAxiosApiError(error, "Failed to deny support session.")
        .message,
    };
  }
};
